import appmaker from '@appmaker/core/index';
import { ChartBarIcon, UserGroupIcon } from '@heroicons/react/solid';
import PlobalAnalyzeHome from 'packages/p-analyze/routes/Home';
import PlobalEngangeHome from 'packages/p-engage/routes/Home';

const Plobal = {
    id: 'plobal',
    name: 'Plobal',
    activate: () => {
        appmaker.registerRoute({
            routeName: '/p-analyze',
            component: PlobalAnalyzeHome,
        });
        appmaker.registerRoute({
            routeName: '/p-engage',
            component: PlobalEngangeHome,
        });
        /**
         * Menu Items
         */
        appmaker.registerSideBarMenu({
            name: 'Analyze',
            routeName: '/p-analyze',
            icon: ChartBarIcon,
        }, 9);
        appmaker.registerSideBarMenu({
            name: 'Engage',
            routeName: '/p-engage',
            icon: UserGroupIcon,
        }, 9);
    }
}

export default Plobal